import React from "react";
import "../nav/Navigation.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/free-solid-svg-icons";

interface Props {
  minutes: number
}

function TimeTag(props: Props) {

    return (
        <>
            <div className={`user-tag d-inline-block`}>
              <div className={"d-inline-block"}><FontAwesomeIcon className="animated zoomIn fa-solid" icon={faClock}/></div>
              <div className={"d-inline-block ml-1"}>{props.minutes}</div>
            </div>
        </>
    )
}

export default TimeTag;
